import { useState, useEffect } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import { auth } from '../lib/api';
import { ArrowLeft } from 'lucide-react';
import AuthFrame from '../components/AuthFrame';

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const token = searchParams.get('token');

  useEffect(() => {
    if (!token) {
      toast.error('Invalid reset link');
      navigate('/login');
    }
  }, [token, navigate]);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      toast.error('Passwords do not match');
      return;
    }

    if (newPassword.length < 8) {
      toast.error('Password must be at least 8 characters');
      return;
    }

    if (!token) return;

    setLoading(true);

    try {
      const response = await auth.resetPassword({ token, newPassword });
      toast.success(response.message);
      setTimeout(() => navigate('/login'), 2000);
    } catch (error) {
      toast.error(error instanceof Error ? error.message : 'Failed to reset password');
    } finally {
      setLoading(false);
    }
  }

  if (!token) {
    return null;
  }

  return (
    <AuthFrame kicker="Password" title="Set a new password.">
      <form onSubmit={handleSubmit} className="space-y-5">
        <div>
          <label htmlFor="newPassword" className="label">New password</label>
          <input
            id="newPassword"
            type="password"
            required
            minLength={8}
            autoComplete="new-password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            className="field"
          />
          <p className="kicker mt-1">At least 8 characters</p>
        </div>

        <div>
          <label htmlFor="confirmPassword" className="label">Confirm password</label>
          <input
            id="confirmPassword"
            type="password"
            required
            minLength={8}
            autoComplete="new-password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            className="field"
          />
        </div>

        <button type="submit" disabled={loading} className="btn btn-accent w-full">
          {loading ? 'Resetting…' : 'Reset password'}
        </button>
      </form>

      <p className="mt-6">
        <Link to="/login" className="kicker inline-flex items-center gap-1 hover:text-ink">
          <ArrowLeft className="w-3 h-3" />
          Back to sign in
        </Link>
      </p>
    </AuthFrame>
  );
}
